import { useMemo } from 'react';
import { FormSchemaConfig } from '../../types/form/schema.types';
import { FormState } from '../../types';
import { buildGiftHospitalityDonationRequestDetailsSchema } from '../GiftHospitalityDonation/giftHospitalityDonationRequestDetails.schema';
import { useCreatorPersonTag } from '../GiftHospitalityDonation/useCreatorPersonTag';
import { GIFT_HOSPITALITY_DONATION_DUBLIN_SECTION_KEYS } from './constants';

export const useGiftHospitalityDonationDublinGiftHospitalityDonationDublinRequestDetailsSchema =
  (formState: FormState): FormSchemaConfig => {
    const creatorTag = useCreatorPersonTag(formState);

    return useMemo(
      () =>
        buildGiftHospitalityDonationRequestDetailsSchema(
          formState,
          GIFT_HOSPITALITY_DONATION_DUBLIN_SECTION_KEYS.giftHospitalityDonationDublinRequestDetails,
          creatorTag,
        ),
      [creatorTag, formState],
    );
  };
